// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import DECLINE from "../../assets/Declined.png";

class DocDeclinedStatusUpdate extends Component {
  _onClose = () => {
    this.props.toggleModalPopUp("docDeclinedConfirmationPopup", false);
  };

  render() {
    return (
      <Modal open onClose={this._onClose} center>
        <div
          className="quotationtopbar-container"
          data-test="quotationtopbar-container">
          <div className="docstatus-accptancereject-image">
            <div className="docstatus-confirm-text">
              <div className="doc-confirm-seal">
                <img
                  src={DECLINE}
                  alt="Decline badge"
                  className="document-sent-confirmation-image"
                />
              </div>
              <div className="docstatus-confirm-title">
                You have declined this document.
              </div>
              <div className="docstatus-confirm-subtitle">
                You can add comments to support your action under Notes.
              </div>
              <div className="acceptance-docstatus-confirm-footer">
                You can access this document any time using the link in the
                email.
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default DocDeclinedStatusUpdate;



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/DocDeclinedStatusUpdate.js